/**
 * Returns a short address with only street name and neighborhood,
 * stripping the house number and city/state suffix.
 *
 * "Alameda Santos, 1165 - Jardim Paulista - São Paulo, SP, ..."
 *   → "Alameda Santos - Jardim Paulista"
 */
export function formatAddressShort(address: string | undefined): string {
  if (!address) return "";
  const parts = address.split(" - ");
  const street = parts[0].replace(/,\s*\d+.*$/, "").trim();
  if (parts.length > 1) {
    return `${street} - ${parts[1].trim()}`;
  }
  return street;
}
